import { render } from "./SchedulingCrudView.vue?vue&type=template&id=5c56f0f6&scoped=true"
import script from "./SchedulingCrudView.vue?vue&type=script&lang=js"
export * from "./SchedulingCrudView.vue?vue&type=script&lang=js"

import "./SchedulingCrudView.vue?vue&type=style&index=0&id=5c56f0f6&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c56f0f6"]])

export default __exports__